export enum ETrainingLabel {
  Completed = 'Completed',
  Outstanding = 'Outstanding',
  Assigned = 'Assigned'
}

export enum EBadgeStatus {
  unlocked = 'unlocked',
  locked = 'locked'
}

export enum Course_Status {
  COMPLETE_LEARNING_COURSE = 'COMPLETE_LEARNING_COURSE',
  REPORT_EMAIL = 'REPORT_EMAIL',
}